module.exports = __webpack_public_path__ + "8c645c7c43ddcfa1fed34dcbb33c56e2.MP3";